module.exports = __webpack_public_path__ + "static/img/home-pub-sp.12329888.jpg";